var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c("nav", { attrs: { "aria-label": "breadcrumb" } }, [
        _c("ol", { staticClass: "breadcrumb" }, [
          _c(
            "li",
            { staticClass: "breadcrumb-item" },
            [
              _c("router-link", { attrs: { to: { name: "Home" } } }, [
                _vm._v("Accueil"),
              ]),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "li",
            {
              staticClass: "breadcrumb-item active",
              attrs: { "aria-current": "page" },
            },
            [_vm._v("Nouveau contrat")]
          ),
        ]),
      ]),
      _vm._v(" "),
      _c(
        "b-form",
        { on: { submit: _vm.onSubmit } },
        [
          _c(
            "b-card-group",
            { attrs: { deck: "" } },
            [
              _c(
                "b-card",
                {
                  attrs: {
                    header: "1. Paramétrez l'offre",
                    "header-tag": "header",
                  },
                },
                [
                  _c(
                    "b-card-group",
                    { staticClass: "home-card", attrs: { deck: "" } },
                    [
                      _c(
                        "b-container",
                        [
                          _c(
                            "b-row",
                            [
                              _c(
                                "b-col",
                                [
                                  _c(
                                    "b-form-group",
                                    {
                                      attrs: {
                                        id: "input-group-offer",
                                        label: "Type d'offre",
                                        "label-for": "input-offer",
                                      },
                                    },
                                    [
                                      _c("b-form-select", {
                                        attrs: {
                                          id: "input-offer",
                                          options: _vm.offersInForm,
                                          required: "",
                                        },
                                        model: {
                                          value: _vm.form.cont_off_id,
                                          callback: function ($$v) {
                                            _vm.$set(
                                              _vm.form,
                                              "cont_off_id",
                                              $$v
                                            )
                                          },
                                          expression: "form.cont_off_id",
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "b-col",
                                { staticClass: "marginable" },
                                [
                                  _c(
                                    "b-form-checkbox",
                                    {
                                      attrs: {
                                        id: "input-is-project",
                                        value: true,
                                        "unchecked-value": false,
                                      },
                                      model: {
                                        value: _vm.form.cont_is_project,
                                        callback: function ($$v) {
                                          _vm.$set(
                                            _vm.form,
                                            "cont_is_project",
                                            $$v
                                          )
                                        },
                                        expression: "form.cont_is_project",
                                      },
                                    },
                                    [
                                      _vm._v(
                                        "\n                  Mode projet "
                                      ),
                                      _c("font-awesome-icon", {
                                        attrs: {
                                          id: "tooltip-mode-project",
                                          icon: ["fas", "info-circle"],
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "b-tooltip",
                                    {
                                      attrs: {
                                        target: "tooltip-mode-project",
                                        triggers: "hover",
                                      },
                                    },
                                    [
                                      _vm._v(
                                        "\n                  Cela peut concerner n'importe quelle offre. On devra spécifier une date de fin.\n                "
                                      ),
                                    ]
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _vm.form.cont_off_id === 1
                            ? _c(
                                "b-row",
                                [
                                  _c("div", { staticClass: "info-danger" }, [
                                    _vm._v(
                                      "\n                Choisir une offre groupe vous obligera à paramétrer une liste de modules autorisés.\n                "
                                    ),
                                    _c("br"),
                                    _vm._v(
                                      "\n                " +
                                        _vm._s(
                                          "Cela ne concerne que les groupes ayant des demandes spécifiques " +
                                            "(date de déploiement, modules particuliers...)"
                                        ) +
                                        "\n              "
                                    ),
                                  ]),
                                  _vm._v(" "),
                                  _c(
                                    "b-form-group",
                                    {
                                      attrs: {
                                        id: "input-group-offer-group-name",
                                        label:
                                          "Nom du groupe (exemple : COLISEE, ORPEA, ...)",
                                        "label-for": "input-offer-group-name",
                                      },
                                    },
                                    [
                                      _c("b-form-input", {
                                        attrs: {
                                          id: "input-internal-name",
                                          type: "text",
                                          required: "",
                                        },
                                        model: {
                                          value: _vm.form.offer_group_name,
                                          callback: function ($$v) {
                                            _vm.$set(
                                              _vm.form,
                                              "offer_group_name",
                                              $$v
                                            )
                                          },
                                          expression: "form.offer_group_name",
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              )
                            : _vm._e(),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "b-card",
                {
                  attrs: {
                    header: "2. Paramétrez les dates",
                    "header-tag": "header",
                  },
                },
                [
                  _c(
                    "b-card-group",
                    { staticClass: "home-card", attrs: { deck: "" } },
                    [
                      _c(
                        "b-container",
                        [
                          _c(
                            "b-form-group",
                            [
                              _c(
                                "label",
                                { staticClass: "d-block" },
                                [
                                  _vm._v("Date de début "),
                                  _c("font-awesome-icon", {
                                    attrs: {
                                      id: "tooltip-date-start",
                                      icon: ["fas", "info-circle"],
                                    },
                                  }),
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "b-tooltip",
                                {
                                  attrs: {
                                    target: "tooltip-date-start",
                                    triggers: "hover",
                                  },
                                },
                                [
                                  _vm._v(
                                    "\n                Date de la formation\n              "
                                  ),
                                ]
                              ),
                              _vm._v(" "),
                              _c("b-form-input", {
                                attrs: {
                                  id: "input-date-start",
                                  type: "date",
                                  required: "",
                                },
                                model: {
                                  value: _vm.form.cont_date_start,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.form, "cont_date_start", $$v)
                                  },
                                  expression: "form.cont_date_start",
                                },
                              }),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _vm.form.cont_is_project
                            ? _c(
                                "b-form-group",
                                {
                                  attrs: {
                                    id: "input-group-date-end",
                                    label: "Date de fin",
                                    "label-for": "input-date-end",
                                  },
                                },
                                [
                                  _c("b-form-input", {
                                    attrs: {
                                      id: "input-date-end",
                                      type: "date",
                                      required: "",
                                    },
                                    model: {
                                      value: _vm.form.cont_date_end,
                                      callback: function ($$v) {
                                        _vm.$set(_vm.form, "cont_date_end", $$v)
                                      },
                                      expression: "form.cont_date_end",
                                    },
                                  }),
                                ],
                                1
                              )
                            : _vm._e(),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "b-card-group",
            { attrs: { deck: "" } },
            [
              _c(
                "b-card",
                {
                  attrs: {
                    header: "3. Paramétrez les montants",
                    "header-tag": "header",
                  },
                },
                [
                  _c(
                    "b-card-group",
                    { staticClass: "home-card", attrs: { deck: "" } },
                    [
                      _c(
                        "b-container",
                        [
                          _c(
                            "b-row",
                            [
                              _c(
                                "b-col",
                                [
                                  _c(
                                    "b-form-group",
                                    {
                                      attrs: {
                                        id: "input-group-subscription-amount",
                                        label: "Montant de l'abonnement",
                                        "label-for":
                                          "input-subscription-amount",
                                      },
                                    },
                                    [
                                      _c("b-form-input", {
                                        attrs: {
                                          id: "input-subscription-amount",
                                          type: "number",
                                          step: "any",
                                          required: "",
                                        },
                                        model: {
                                          value:
                                            _vm.form.cont_subscription_amount,
                                          callback: function ($$v) {
                                            _vm.$set(
                                              _vm.form,
                                              "cont_subscription_amount",
                                              $$v
                                            )
                                          },
                                          expression:
                                            "form.cont_subscription_amount",
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "b-row",
                            [
                              _c(
                                "b-col",
                                [
                                  _c(
                                    "b-form-group",
                                    {
                                      attrs: {
                                        id: "input-group-formation-amount",
                                        label: "Montant de la formation",
                                        "label-for": "input-formation-amount",
                                      },
                                    },
                                    [
                                      _c("b-form-input", {
                                        attrs: {
                                          id: "input-formation-amount",
                                          type: "number",
                                          step: "any",
                                          required: "",
                                        },
                                        model: {
                                          value: _vm.form.cont_formation_amount,
                                          callback: function ($$v) {
                                            _vm.$set(
                                              _vm.form,
                                              "cont_formation_amount",
                                              $$v
                                            )
                                          },
                                          expression:
                                            "form.cont_formation_amount",
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "b-row",
                            [
                              _c(
                                "b-col",
                                [
                                  _c(
                                    "b-form-group",
                                    {
                                      attrs: {
                                        id: "input-group-material-amount",
                                        label: "Montant du matériel",
                                        "label-for": "input-material-amount",
                                      },
                                    },
                                    [
                                      _c("b-form-input", {
                                        attrs: {
                                          id: "input-material-amount",
                                          type: "number",
                                          step: "any",
                                          required: "",
                                        },
                                        model: {
                                          value: _vm.form.cont_material_amount,
                                          callback: function ($$v) {
                                            _vm.$set(
                                              _vm.form,
                                              "cont_material_amount",
                                              $$v
                                            )
                                          },
                                          expression:
                                            "form.cont_material_amount",
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "b-card",
                {
                  attrs: {
                    header: "4. Paramétrez les autres informations",
                    "header-tag": "header",
                  },
                },
                [
                  _c(
                    "b-card-group",
                    { staticClass: "home-card", attrs: { deck: "" } },
                    [
                      _c(
                        "b-container",
                        [
                          _c(
                            "b-row",
                            [
                              _c(
                                "b-col",
                                [
                                  _c(
                                    "b-form-group",
                                    {
                                      attrs: {
                                        id: "input-group-comment",
                                        label: "Commentaires",
                                        "label-for": "input-comment",
                                      },
                                    },
                                    [
                                      _c("b-form-textarea", {
                                        attrs: {
                                          id: "textarea",
                                          placeholder: "",
                                          rows: "3",
                                          "max-rows": "6",
                                        },
                                        model: {
                                          value: _vm.form.cont_comment,
                                          callback: function ($$v) {
                                            _vm.$set(
                                              _vm.form,
                                              "cont_comment",
                                              $$v
                                            )
                                          },
                                          expression: "form.cont_comment",
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "b-row",
                            [
                              _c(
                                "b-col",
                                { staticClass: "marginable" },
                                [
                                  _c(
                                    "b-form-checkbox",
                                    {
                                      attrs: {
                                        id: "input-is-group",
                                        value: true,
                                        "unchecked-value": false,
                                      },
                                      model: {
                                        value: _vm.form.is_group,
                                        callback: function ($$v) {
                                          _vm.$set(_vm.form, "is_group", $$v)
                                        },
                                        expression: "form.is_group",
                                      },
                                    },
                                    [
                                      _vm._v(
                                        "\n                  Ce contrat concerne un groupement d'établissements "
                                      ),
                                      _c("font-awesome-icon", {
                                        attrs: {
                                          id: "tooltip-mode-group",
                                          icon: ["fas", "info-circle"],
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "b-tooltip",
                                    {
                                      attrs: {
                                        target: "tooltip-mode-group",
                                        triggers: "hover",
                                      },
                                    },
                                    [
                                      _vm._v(
                                        "\n                  Cela signifie qu'il y aura un établissement parent.\n                "
                                      ),
                                    ]
                                  ),
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _vm.form.is_group
                                ? _c(
                                    "b-col",
                                    [
                                      _c(
                                        "b-form-group",
                                        {
                                          attrs: {
                                            id: "input-group-group-name",
                                            label:
                                              "Nom du groupement (exemple : GCSMS, GERONTONUM, COLISEE, ...)",
                                            "label-for": "input-group-name",
                                          },
                                        },
                                        [
                                          _c("b-form-input", {
                                            attrs: {
                                              id: "input-internal-name",
                                              type: "text",
                                              required: "",
                                            },
                                            model: {
                                              value: _vm.form.group_name,
                                              callback: function ($$v) {
                                                _vm.$set(
                                                  _vm.form,
                                                  "group_name",
                                                  $$v
                                                )
                                              },
                                              expression: "form.group_name",
                                            },
                                          }),
                                        ],
                                        1
                                      ),
                                    ],
                                    1
                                  )
                                : _vm._e(),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "b-container",
            [
              _c(
                "b-row",
                [
                  _c(
                    "b-col",
                    [
                      _c(
                        "b-button",
                        { attrs: { type: "submit", variant: "primary" } },
                        [_vm._v("Enregistrer")]
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }